<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="false"
    :full-screen="true"
    :max-width="1600"
    :persistent="true"
  >
    <template slot="header">
      <span>Commercial Bill Of Lading Finished Goods</span>
    </template>

    <template slot="body">
      <v-row>
        <v-col cols="12">
          <v-card elevation="0" outlined>
            <v-data-table
              :headers="headers"
              :items="finishedGoods"
              hide-default-footer
              :items-per-page="-1"
              fixed-header
              :height="tableHeight"
              dense
              :item-class="getFinishedGoodRowClass"
            >
              <template
                v-for="h in headers"
                #[`header.${h.value}`]="{ header }"
              >
                <v-tooltip
                  v-if="h.fullText"
                  :key="h.value"
                  top
                >
                  <template #activator="{ on }">
                    <span v-on="on">{{ header.text }}</span>
                  </template>
                  <span>{{ header.fullText }}</span>
                </v-tooltip>
                <span
                  v-else
                  :key="h.value"
                >
                  {{ h.text }}
                </span>
              </template>

              <template #[`item.tag_id`]="{ item }">
                <span style="font-weight: bold">
                  {{ getFinishedGoodTagId(item) }}
                </span>
              </template>

              <template #[`item.tag_number`]="{ item }">
                <span style="font-weight: bold">
                  {{ getFinishedGoodTagNumber(item) }}
                </span>
              </template>

              <template #[`item.sequence_number`]="{ item }">
                {{ getFinishedGoodSequenceNumber(item) }}
              </template>

              <template #[`item.finished_good.type.name`]="{ item }">
                {{ getFinishedGoodTypeName(item) }}
              </template>

              <template #[`item.finished_good.aluminum_die.code`]="{ item }">
                {{ getFinishedGoodAluminumDieCode(item) }}
              </template>

              <template #[`item.finished_good.int_color.code`]="{ item }">
                {{ getFinishedGoodIntColorCode(item) }}
              </template>

              <template #[`item.finished_good.ext_color.code`]="{ item }">
                {{ getFinishedGoodExtColorCode(item) }}
              </template>

              <template #[`item.status`]="{ item }">
                <v-chip
                  v-if="hasFinishedGoodStatus(item)"
                  small
                  :color="getFinishedGoodStatusColor(item)"
                  text-color="white"
                >
                  {{ getFinishedGoodStatusName(item) }}
                </v-chip>
              </template>

              <template #[`item.length`]="{ item }">
                {{ getFinishedGoodLength(item) }}
              </template>

              <template #[`item.weight`]="{ item }">
                <span
                  v-if="
                    item.sqft ||
                    item.type_id === finishedGoodCommercialTypeIdFrame ||
                    item.type_id === finishedGoodCommercialTypeIdSlab
                  "
                >
                  {{ getFinishedGoodWeight(item) }}
                </span>
                <span v-else>
                  <v-tooltip left>
                    <template #activator="{ on }">
                      <span
                        style="color: red; font-weight: bold"
                        v-on="on"
                      >
                        !
                      </span>
                    </template>
                    <span>Missing Sqft; Unable to calculate weight</span>
                  </v-tooltip>
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>
export default {
  name: 'CommercialBillOfLadingFinishedGoodsDialog',
  props: {
    finishedGoods: {
      type: Array,
      default: () => [],
    },
    tableHeight: {
      type: Number,
      default: 900,
    },
    finishedGoodCommercialTypeIdFrame: {
      type: Number,
      required: true,
    },
    finishedGoodCommercialTypeIdSlab: {
      type: Number,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        { text: 'Tag ID', value: 'tag_id', sortable: false, width: '10%' },
        {
          text: 'Tag #',
          fullText: 'Window Number on Drawing',
          value: 'tag_number',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Sequence #',
          value: 'sequence_number',
          sortable: false,
          width: '5%',
        },
        {
          text: 'Type',
          value: 'finished_good.type.name',
          width: '5%',
          sortable: false,
        },
        {
          text: 'Die',
          value: 'finished_good.aluminum_die.code',
          width: '5%',
          sortable: false,
        },
        {
          text: 'Int. Color',
          value: 'finished_good.int_color.code',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Ext. Color',
          value: 'finished_good.ext_color.code',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Length (inches)',
          value: 'length',
          align: 'end',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Weight (kg)',
          value: 'weight',
          align: 'end',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          align: 'center',
          sortable: false,
          width: '10%',
        },
      ];
    },
  },
  methods: {
    open() {
      this.$refs.dialogBox.open();
    },

    getFinishedGoodRowClass() {
    //   return 'commercial-bol-row-finished-good';
       return '';
    },

    getFinishedGoodTagId(finishedGood) {
      return finishedGood && finishedGood.tag_id ? finishedGood.tag_id : '-';
    },

    getFinishedGoodTagNumber(finishedGood) {
      return finishedGood && finishedGood.tag_number ? finishedGood.tag_number : '-';
    },

    getFinishedGoodSequenceNumber(finishedGood) {
      const tagId = finishedGood?.tag_id;
      if (!tagId) return '-';

      const parts = tagId.split('-');
      return parts.length > 1 ? parts[parts.length - 1] : '-';
    },

    getFinishedGoodTypeName(finishedGood) {
      return finishedGood && finishedGood.type && finishedGood.type.name ? finishedGood.type.name : '-';
    },


    getFinishedGoodAluminumDieCode(finishedGood) {
      return finishedGood && finishedGood.aluminum_die && finishedGood.aluminum_die.code ? finishedGood.aluminum_die.code : '-';
    },

    getFinishedGoodIntColorCode(finishedGood) {
      return finishedGood && finishedGood.int_color && finishedGood.int_color.code ? finishedGood.int_color.code : '-';
    },

    getFinishedGoodExtColorCode(finishedGood) {
      return finishedGood && finishedGood.ext_color && finishedGood.ext_color.code ? finishedGood.ext_color.code : '-';
    },

    hasFinishedGoodStatus(finishedGood) {
      return !!(finishedGood && finishedGood.status);
    },

    getFinishedGoodStatusColor(finishedGood) {
      return finishedGood && finishedGood.status ? finishedGood.status.color : '#000000';
    },

    getFinishedGoodStatusName(finishedGood) {
      return finishedGood && finishedGood.status ? finishedGood.status.name : '';
    },

    getFinishedGoodSqft(finishedGood) {
      return finishedGood && finishedGood.sqft ? `${finishedGood.sqft.toFixed(2)} sqft` : '-';
    },

    getFinishedGoodWidth(finishedGood) {
      return finishedGood
        && finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame
        && finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab
        && finishedGood.width
        ? this.displayInchesWithFraction(finishedGood.width)
        : '-';
    },

    getFinishedGoodHeight(finishedGood) {
      return finishedGood
        && finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame
        && finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab
        && finishedGood.height
        ? this.displayInchesWithFraction(finishedGood.height)
        : '-';
    },

    getFinishedGoodLength(finishedGood) {
      if (!finishedGood) return '-';

      const isValidType =
        finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame ||
        finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab;

      if (!isValidType) return '-';

      const length = this.getLengthFromFinishedGoodComponent(finishedGood);
      return length ? this.displayInchesWithFraction(length) : '-';
    },

    getFinishedGoodWeight(finishedGood) {
      if (!finishedGood || !finishedGood.type) return '-';

      const weight = this.getFinishedGoodWeightKilograms(finishedGood);

      return weight
        ? parseFloat(weight).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
        : '-';
    },

    getLengthFromFinishedGoodComponent(finishedGood) {
      if (
        !finishedGood ||
        (finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame &&
          finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab)
      ) {
        return 0;
      }

      if (finishedGood.width != null) {
        return finishedGood.width;
      }

      if (finishedGood.height != null) {
        return finishedGood.height;
      }

      return 0;
    },

    getFinishedGoodWeightKilograms(finishedGood) {
      if (!finishedGood || !finishedGood.type) return 0;

      if (
        finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame ||
        finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab
      ) {
        const length = this.getLengthFromFinishedGoodComponent(finishedGood);
        if (!length) return 0;
        return length * finishedGood.type.weight_ratio;
      }

      return (finishedGood.sqft || 0) * (finishedGood.type.weight_ratio || 0);
    },

    displayInchesWithFraction(inches) {
      const raw = Math.round(inches / 0.0625) * 0.0625;
      const wholeNumber = Math.floor(raw);
      const decInput = parseFloat((raw - wholeNumber).toFixed(4));

      let numerator = 1;
      let denominator = 1;
      let decimalFraction = numerator / denominator;

      while (decimalFraction !== decInput) {
        if (decimalFraction < decInput) {
          numerator += 1;
        } else {
          denominator += 1;
          numerator = Math.floor(decInput * denominator);
        }
        decimalFraction = numerator / denominator;
      }

      let result = '';
      if (wholeNumber > 0) {
        result += `${wholeNumber}"`;
      }

      if (numerator > 0) {
        result += `-${numerator}/${denominator}''`;
      }

      return result;
    },
  },
};
</script>

<style scoped>
::v-deep .commercial-bol-row-finished-good {
  background-color: #dbefdc !important;
}
</style>
